// extracted by mini-css-extract-plugin
export default {"root":"FeedbackModal_root__SqtYl","controls":"FeedbackModal_controls__KItA-"};